import React, { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

const CopyClipboard = props => {
  const [copied, setCopied] = useState(false);
  const [msgTimeout, setMsgTimeout] = useState(0);

  const startMsgTimeout = () => {
    setMsgTimeout(setTimeout(() => setCopied(false), 4000));
  };

  useEffect(() => {
    return () => {
      clearTimeout(msgTimeout);
    };
  }, [msgTimeout]);

  return (
    <CopyToClipboard text={props.text}>
      <button
        className="flatbut iconflatbut"
        title={props.title}
        onClick={() => {
          setCopied(true);
          startMsgTimeout();
        }}
      >
        {copied ? (
          <span className="greentext">{props.successMsg || "Copied"}</span>
        ) : null}
        <i className="material-icons">content_copy</i>
      </button>
    </CopyToClipboard>
  );
};

export default CopyClipboard;
